import kebabCase from 'lodash/kebabCase';
import isPlainObject from 'lodash/isPlainObject';
const transformMetadataToDataAttributes = (metadata) => {
    return Object.keys(metadata).reduce(function (dataAttributesByRef, key) {
        const dataAttribute = kebabCase(key);
        const dataAttributeKey = `data-eb-${dataAttribute}`;
        let metadataValue = metadata[key];
        if (isPlainObject(metadataValue) || Array.isArray(metadataValue)) {
            metadataValue =
                Object.keys(metadataValue).length > 0 ? JSON.stringify(metadataValue) : null;
        }
        dataAttributesByRef[dataAttributeKey] = metadataValue;
        return dataAttributesByRef;
    }, {});
};
export const getItemMetadataAttributes = (itemId, metadata) => {
    return {
        'data-eb-item-id': itemId,
        ...transformMetadataToDataAttributes(metadata || {}),
    };
};
